import apiRequest from '../../../http/api-request'
import authService from '@/auth/authService'

let fetchCharitiesInFlight = null
const fetchCharityConfigInFlight = new Map()

export default {
  fetchCharities({ commit }) {
    if (fetchCharitiesInFlight) {
      return fetchCharitiesInFlight
    }

    fetchCharitiesInFlight = new Promise((resolve, reject) => {
      apiRequest
        .doGetRequest(
          `/client/charities`,
          {},
          { 'X-Harness-JWT': authService.getToken() },
          { skipCache: true }
        )
        .then((charities) => {
          commit('SET_CHARITIES', charities)
          resolve(charities)
        })
        .catch((error) => reject(error))
        .finally(() => {
          fetchCharitiesInFlight = null
        })
    })

    return fetchCharitiesInFlight
  },
  async fetchCharityConfig({ commit }, { charityId }) {
    if (fetchCharityConfigInFlight.has(charityId)) {
      return fetchCharityConfigInFlight.get(charityId)
    }

    const request = (async () => {
      try {
        const response = await apiRequest.doGetRequest(`/whitelabel/${charityId}/config`)
        commit('SET_ACTIVE_CHARITY_INFO', response)
        return response
      } catch (error) {
        if (error?.response?.status === 404) {
          return null
        }
        throw error
      } finally {
        fetchCharityConfigInFlight.delete(charityId)
      }
    })()

    fetchCharityConfigInFlight.set(charityId, request)
    return request
  },
}
